/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_appsync_graphqlEndpoint": "https://oeiz37c2j5amzajbrit2prkz3y.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "us-east-2:92fc0b76-35dc-4514-a742-25bbbdc38f28",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_413MvRfyh",
    "aws_user_pools_web_client_id": "6hu1qhp5r11cut90uu4b58u77v",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "compasslanguagesportf6215d1ef13a45ffac84169522e71d6e-prod",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
